import BaseRepository from './base.repository';

class KnowledgeRepository extends BaseRepository {
  constructor() {
    super('/knowledge');
  }

  ask(question) {
    return this.client.post('ask', { question });
  }
}

export default new KnowledgeRepository();
